import React, { memo } from 'react';

const MapMark = memo(({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0004 12.9198C13.7345 12.9198 15.1404 11.5408 15.1404 9.83977C15.1404 8.13873 13.7345 6.75977 12.0004 6.75977C10.2662 6.75977 8.86035 8.13873 8.86035 9.83977C8.86035 11.5408 10.2662 12.9198 12.0004 12.9198Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M12 2C7.58 2 4 5.51 4 9.84C4 14.17 8.58 18.69 12 22C15.42 18.69 20 14.17 20 9.84C20 5.51 16.42 2 12 2Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default MapMark;
